import script from "./EventSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSchedule.vue?vue&type=script&setup=true&lang=js"

import "./EventSchedule.vue?vue&type=style&index=0&id=7ae6d274&scoped=true&lang=css"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae6d274"]])

export default __exports__